module.exports = __webpack_public_path__ + "static/media/logo_fondo_portal_vectorized.f9691350.png";